import $modal from '@core/services/modal';
import modalBroadcastMessages from '@core/modals/modalBroadcastMessages.vue';
import { EventBusCore } from '@core/services/util';
import ENUMS from '@core/classes/Enums';
import auth from '@core/services/auth';

let subscribedEvents = [];

export const broadcastSubscribeEvents = (meetingHub, subscribeTo) => {
	subscribeTo.map(subscribe => {
		meetingHub.subscribeToGroupEvent(subscribe.event, 'Broadcast', subscribe.callback);
		subscribedEvents.push(subscribe.event);
	});
};

export const broadcastUnsubscribeEvents = (meetingHub, subscribeTo) => {
	subscribeTo.map(subscribe => {
		meetingHub.unsubscribeToGroupEvent(subscribe.event);

		subscribedEvents = subscribedEvents.filter(sEvent => sEvent !== subscribe.event);
	});
};

export const broadcastUnsubscribeAllEvents = meetingHub => {
	subscribedEvents.map(sEvent => {
		meetingHub.unsubscribeToGroupEvent(sEvent);
	});
	subscribedEvents = [];
};

export const broadcastEmitEvent = (meetingHub, eventName, data) => {
	meetingHub.broadcastGroupEvent(eventName, 'Broadcast', data);
};

const canTriggerBroadcast = message => {
	const currentUser = auth.getTokenPayload();

	const parsedMessage = typeof message === 'string' ? JSON.parse(message) : message;

	// If specific users are targeted, check if current user is in the list
	if (parsedMessage.users && parsedMessage.users.length > 0) {
		return parsedMessage.users.includes(currentUser.id);
	}

	// If no specific targeting is set, message is for everyone
	if ((!parsedMessage.stores || parsedMessage.stores.length === 0) && (!parsedMessage.positions || parsedMessage.positions.length === 0)) {
		return true;
	}

	// Check if any of user's store codes are targeted
	const storeMatch =
		!parsedMessage.stores ||
		parsedMessage.stores.length === 0 ||
		(Array.isArray(currentUser.EmployeeAccess.StoreCodes) && currentUser.EmployeeAccess.StoreCodes.some(storeCode => parsedMessage.stores.includes(storeCode)));

	// Check if user's position is targeted
	const positionMatch = !parsedMessage.positions || parsedMessage.positions.length === 0 || parsedMessage.positions.includes(currentUser.PositionCode);

	return storeMatch && positionMatch;
};

export const broadcastCallbacks = {
	broadcastSendGlobalMessages: data => {
		if (canTriggerBroadcast(data)) {
			$modal.open(modalBroadcastMessages, {
				name: 'modalBroadcastMessages',
				passedData: { data: JSON.parse(data) },
				backdrop: true,
			});
		}
	},
	openHelpNotification: data => {
		const payload = auth.getTokenPayload();
		if (data.userEmail === payload.EmployeeEmail) {
			EventBusCore.emit('helpNotification', true);
			localStorage.setItem(`helpNotification-${data.key}`, true);
		}
	},
	broadcastPostDeployLogsMessage: data => {
		if (canTriggerBroadcast(data)) {
			localStorage.setItem('openDeployLogsForVersion', data);
		}
	},
};
